import React from "react";
import styled, { css } from "styled-components";
import _ from "lodash";

import { PageProps } from "src/pages/Router/routes";
import { TabbedNavigation } from "src/library/components/TabbedNavigation";
import {
  LeadTimeSettingsTabCustomers,
  LeadTimeSettingsTabDrops,
  LeadTimeSettingsTabGlobal
} from "src/core/shared/components/lead-times-settings";
import {
  Layout,
  MainContentWrapper
} from "src/core/shared/components/Layout";

/**
 * Lead time setings page.
 */
const LeadTimesSettingsPage: React.ReactFCWithChildren<PageProps<unknown>> = props => {
  return (
    <Layout {...props}>
      <MainContentWrapper fill>
        <TabbedTableWrapper>
          <TabbedNavigation
            defaultTab="global"
            tabs={[
              {
                title: "Global",
                name: "global",
                content: () => (<LeadTimeSettingsTabGlobal {...props} />)
              },
              {
                title: _.capitalize(`${props.terminology.customer.plural.text}`),
                name: "customers",
                content: () => (<LeadTimeSettingsTabCustomers {...props} />)
              },
              {
                title: _.capitalize(`${props.terminology.drop.plural.text}`),
                name: "drops",
                content: () => (<LeadTimeSettingsTabDrops {...props} />)
              }
            ]}
          />
        </TabbedTableWrapper>
      </MainContentWrapper>
    </Layout>
  );
};

const TabbedTableWrapper = styled.div`
  ${({ theme }) => css`
    margin-top: ${theme.spacing.margins.xs};
  `}
`;

export default LeadTimesSettingsPage;
